import { render, staticRenderFns } from "./partShipment.vue?vue&type=template&id=ff5397dc&scoped=true"
import script from "./partShipment.vue?vue&type=script&lang=js"
export * from "./partShipment.vue?vue&type=script&lang=js"
import style0 from "./partShipment.vue?vue&type=style&index=0&id=ff5397dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5397dc",
  null
  
)

export default component.exports